document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".sarezah-header__toggle");
  const nav = document.querySelector(".sarezah-header__nav");

  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      nav.classList.toggle("active");
    });
  }
});